import React from 'react';
import { number, string } from 'prop-types';

import { MapClusterContainer } from './styles';

export default function MapCluster({ color, count }) {
  return (
    <MapClusterContainer color={color} count={count}>
      {count}
    </MapClusterContainer>
  );
}

MapCluster.defaultProps = {
  color: '#000',
  count: 0,
};

MapCluster.propTypes = {
  color: string,
  count: number,
};
